import { motion } from "framer-motion";

const SPACES = [
  { src: "/images/deck.png", title: "The deck", note: "Edge-mounted, washing the boards in amber", ratio: "aspect-[4/5]" },
  { src: "/images/balcony.png", title: "The balcony", note: "Sunset on the railing, city behind", ratio: "aspect-[4/5]" },
  { src: "/images/garden.png", title: "The garden", note: "A path of warm pools through the green", ratio: "aspect-[4/5]" },
];

export const Gallery = () => (
  <section id="gallery" className="py-32 sm:py-40" data-testid="gallery-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-10">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="text-xs uppercase tracking-[0.3em] text-amber-400 mb-6"
      >
        In the wild
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
        className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-stone-50 mb-20"
      >
        Everywhere the <span className="italic text-amber-400">sun</span> goes.
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {SPACES.map((s, i) => (
          <motion.figure
            key={s.title}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9, delay: i * 0.15, ease: [0.16, 1, 0.3, 1] }}
            className={`group ${i === 1 ? "md:mt-16" : ""}`}
            data-testid={`gallery-${s.title.replace("The ", "").toLowerCase()}`}
          >
            <div className={`relative overflow-hidden rounded-2xl ${s.ratio} clip-frame`}>
              <img
                src={s.src}
                alt={`LumaDeck installed on ${s.title.toLowerCase()}`}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <figcaption className="mt-5">
              <div className="font-serif text-2xl text-stone-50">{s.title}</div>
              <div className="text-sm text-stone-400 mt-1">{s.note}</div>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
